if (document.querySelector('.mw_wp_form')) {
  // セレクトボックスのデフォルト文
  // $('select option[value=""]').html('----')
  // アップロードするファイルのパスを掲載
  // $('input[type=file]').on('change', 'input', function() {
  //   $('#upval').html(this.value)
  // })
  // jQuery-Validation-Engine
  const formDOM = $('.mw_wp_form')

  if (document.querySelector('[name^="ok"]')) {
    // 規約同意のエラー文を変更する
    document.querySelector('[name^="ok"]').setAttribute('data-errormessage', '同意の上チェックしてください')
  }
  $(window).on('load scroll resize focus blur click ', function () {
    document.querySelector('input[type="submit"]').removeAttribute('disabled') // MW側のSubmit禁止処理を外す
  })

  formDOM.find('form').validationEngine({
    scrollOffset: 200,
  })
  // jQuery-Validation-Engine for MW WP Form
  /*
  必須入力
  validate【required】
  指定の書式
  validate【custom【email】】
  validate【custom【phone】】
  validate【custom【url】】
  custom【date】
  指定IDと入力内容が一致
  validate【equals【id】】
  指定IDがチェック済みなら必須入力に変更
  validate【condRequired【id】】
  指定範囲の文字数
  validate【maxSize【10】】
  validate【minSize【10】】
  整数のみ
  validate【custom【integer】】
  数字のみ
  validate【custom【number】】
  英数字のみ
  validate【custom【onlyLetterNumber】】
  英字と空白のみ
  validate【custom【onlyLetterSp】】
  数字と空白のみ
  validate【custom【onlyNumberSp】】
  指定範囲の数値
  validate【min【-5】】
  validate【max【30】】
  指定範囲の日付
  validate【custom【date】,past【2010/01/01】】
  validate【custom【date】,future【NOW】】
  チェックボックスのチェック数
  validate【minCheckbox【2】】
  validate【maxCheckbox【2】】
  */
  formDOM.find('input,textarea,select').each(function () {
    let domClass = this.getAttribute('class')
    if (domClass) {
      domClass = domClass.replace(/【/g, '[').replace(/】/g, ']') // ショートコード誤認回避の【】を[]に戻す
      this.setAttribute('class', domClass)
    }
  })

  // 個人情報
  $('.js-mw-agree .mwform-checkbox-field-text').html(
    `入力された個人情報が<a href="${hUrl}contact-privacy/" target="_blank" rel="noopener noreferrer" class="form__link">「お問合せにおける個人情報のご提供に関する同意書」</a>に<br class="pc">基づき取り扱われることに同意して頂ける場合、チェックの上お進みください。`
  )

  // 個人情報（エントリー）
  $('.js-entry-agree .mwform-checkbox-field-text').html(
    `入力された個人情報が<a href="${hUrl}entry-privacy/" target="_blank" rel="noopener noreferrer" class="form__link">「採用応募における個人情報のご提供に関する同意書」</a>に<br class="pc">基づき取り扱われることに同意して頂ける場合、チェックの上お進みください。`
  )

  /*
######## #### ########
    ##    ##  ##     ##
   ##     ##  ########
  ##      ##  ##
######## #### ##
*/
  // 郵便番号から住所を検索する
  /* global  AjaxZip3 */
  const zip = document.getElementById('js-zip')
  if (zip) {
    zip.addEventListener(
      'click',
      function () {
        // 入出力先をnameから指定
        // 郵便番号上3桁もしくは全部, 郵便番号下4桁（不要なら空欄）, 都道府県の出力先, 市区町村～町域の出力先
        AjaxZip3.zip2addr('zip', '', 'address', 'address')
      },
      false
    )
  }

  /*
########     ###    ########  ####  #######
##     ##   ## ##   ##     ##  ##  ##     ##
##     ##  ##   ##  ##     ##  ##  ##     ##
########  ##     ## ##     ##  ##  ##     ##
##   ##   ######### ##     ##  ##  ##     ##
##    ##  ##     ## ##     ##  ##  ##     ##
##     ## ##     ## ########  ####  #######
*/
  // ラジオボタン関連の要素を取得
  const toggleRadio = document.getElementsByClassName('js-formToggle-btn')
  const selectRadio = document.getElementsByClassName('js-formSelect')

  /*
########  #######   ######    ######   ##       ########
   ##    ##     ## ##    ##  ##    ##  ##       ##
   ##    ##     ## ##        ##        ##       ##
   ##    ##     ## ##   #### ##   #### ##       ######
   ##    ##     ## ##    ##  ##    ##  ##       ##
   ##    ##     ## ##    ##  ##    ##  ##       ##
   ##     #######   ######    ######   ######## ########
*/
  formToggleClick()
  function formToggleClick() {
    for (let index = 0; index < toggleRadio.length; index++) {
      const elm = toggleRadio[index]
      elm.addEventListener('change', formToggleSet, false)
    }
  }
  formToggleSet()
  function formToggleSet() {
    for (let index = 0; index < toggleRadio.length; index++) {
      const elm = toggleRadio[index]
      if (elm.checked === true) {
        let isType = '' // 判定フラグ
        if (elm.value === '法人のお客さま') {
          isType = 'corp'
        } else {
          // 個人
          isType = 'person'
        }

        // 表示切り替え
        const toggleItems = document.getElementsByClassName('js-formToggle')
        // すべて閉じる
        for (let index = 0; index < toggleItems.length; index++) {
          const elm = toggleItems[index]
          elm.classList.add('hide')
        }
        const toggleViewItems = document.getElementsByClassName('js-formToggle--' + isType)
        // すべて閉じる
        for (let index = 0; index < toggleViewItems.length; index++) {
          const elm = toggleViewItems[index]
          elm.classList.remove('hide')
        }

        // セレクトボックスの処理
        // 生かす選択肢を取得
        const selectVal = document
          .querySelector('.js-formToggle-selectData.js-formToggle--' + isType)
          .dataset.select.split(',') // ,区切りで配列に変換
        // すべて閉じる
        for (let index = 0; index < selectRadio.length; index++) {
          const elm = selectRadio[index]
          elm.classList.add('hide')
        }
        // 必要な選択肢を表示
        for (let index = 0; index < selectVal.length; index++) {
          const elm = selectVal[index]
          document.querySelector('[value="' + elm + '"]').classList.remove('hide')
        }
        break
      }
    }

    radioSelectSet() // セレクトボックス更新
  }

  /*
########           ######  ######## ##       ########  ######  ########
##     ##         ##    ## ##       ##       ##       ##    ##    ##
##     ##         ##       ##       ##       ##       ##          ##
########  #######  ######  ######   ##       ######   ##          ##
##   ##                 ## ##       ##       ##       ##          ##
##    ##          ##    ## ##       ##       ##       ##    ##    ##
##     ##          ######  ######## ######## ########  ######     ##
*/
  // ラジオボタンによるセレクトボックス
  $('.js-formSelect-acc .mdAcc__btn').on('click', function () {
    $('.js-formSelect-acc').children('.mdAcc__body').toggleClass('active')
  })

  // クリック監視
  radioSelectClick()
  function radioSelectClick() {
    for (let index = 0; index < selectRadio.length; index++) {
      const elm = selectRadio[index]
      elm.addEventListener('change', radioSelectSet, false)
    }
  }
  // 表示反映処理
  radioSelectSet()
  function radioSelectSet() {
    const view = document.getElementById('js-formSelect-view')
    if (view) {
      for (let index = 0; index < selectRadio.length; index++) {
        const elm = selectRadio[index]
        if (elm.checked === true) {
          view.innerText = elm.value
          if (elm.classList.contains('hide')) {
            // 無効化されている選択肢ならリセット
            view.innerText = 'こちらから選択'
            elm.checked = false
          }
          return
        }
      }
      // チェックがなかったらデフォルト文
      view.innerText = 'こちらから選択'
    }
  }

  // セレクトボックスを閉じる処理
  radioSelectClose()
  function radioSelectClose() {
    const formCloses = document.getElementsByClassName('js-formSelect-close')
    for (let index = 0; index < formCloses.length; index++) {
      const formClose = formCloses[index]
      formClose.addEventListener(
        'click',
        function () {
          // document.getElementById('form-select').checked = false
          $('.mdAcc__body.js-formSelect-close').removeClass('active')
        },
        false
      )
    }
  }
}
